var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.07,9a.82.82,0,0,1,0,1.17h0l-1.2,1.2a.81.81,0,0,1-1.15,0h0a.81.81,0,0,1,0-1.15L21.92,9a.83.83,0,0,1,1.15,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a.83.83,0,0,1,.83.83V8.54a.83.83,0,0,1-.83.83h0a.83.83,0,0,1-.83-.83V6.83A.83.83,0,0,1,16,6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.29,10.16a.82.82,0,0,1,0,1.17h0a.83.83,0,0,1-1.17,0L8.94,10.16A.84.84,0,0,1,8.93,9h0a.84.84,0,0,1,1.18,0h0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52,15.19a.83.83,0,0,1,.83.83h0a.83.83,0,0,1-.83.83H6.85A.83.83,0,0,1,6,16H6a.83.83,0,0,1,.83-.83Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.31,20.74a.81.81,0,0,1,0,1.14L10.1,23.09a.81.81,0,0,1-1.14,0H9a.82.82,0,0,1,0-1.16l1.19-1.19A.82.82,0,0,1,11.31,20.74Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22.67a.84.84,0,0,1,.83.84v1.66A.83.83,0,0,1,16,26h0a.83.83,0,0,1-.83-.83V23.46a.83.83,0,0,1,.83-.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.07,21.91a.83.83,0,0,1,0,1.15h0a.83.83,0,0,1-1.15,0l-1.23-1.18a.81.81,0,0,1,0-1.14h0a.82.82,0,0,1,1.16,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.15,15.19A.83.83,0,0,1,26,16h0a.83.83,0,0,1-.83.83H23.48a.83.83,0,0,1-.83-.83h0a.83.83,0,0,1,.83-.83Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16a5,5,0,1,0,5-5A5,5,0,0,0,11,16Zm8.32,0A3.33,3.33,0,1,1,16,12.69,3.33,3.33,0,0,1,19.33,16Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarTheme);
export default __webpack_public_path__ + "static/media/toolbar-theme.87614233.svg";
export { ForwardRef as ReactComponent };